import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import base64 from 'react-native-base64'
import business from '../../functions/logic/Business'
import Spiner from '../../components/Spiner'

export default function Module() {
  const [spiner, setSpiner] = useState(false)
  const [modules, setModules] = useState([])
  const param = useParams()

  useEffect(() => {
    setSpiner(true)
    getBusinessModule(param)
    setSpiner(false)
  }, [param])

  const getBusinessModule = async (param) => {
    const response = await business.moduleLogic(
      localStorage.getItem('userToken'),
      param.businessId
    )
    localStorage.setItem('paramModule', JSON.stringify(param.businessId))
    setModules(response)
  }

  return (
    <>
      <Spiner opt={spiner} />

      <div className="content-wrapper">
        <section className="content-header"></section>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">{global.M_TITLE}</h3>
                  </div>

                  <div className="card-body">
                    <div className="col-md-12">
                      <div className="box box-primary">
                        <div className="box-body">
                          <div className="row modules-div d-flex justify-content-around flex-wrap">
                            {Object.entries(modules).map(
                              ([key, subject], i) => (
                                <div
                                  className="module-item text-center mb-4"
                                  key={i}
                                  style={{
                                    width: '18%',
                                    minWidth: '250px'
                                  }}
                                >
                                  <a
                                    href={
                                      subject.controller +
                                      base64.encode(
                                        subject.id + '-' + subject.businessId
                                      )
                                    }
                                    title={subject.name}
                                    className="thumbnail a_tipo_certificado"
                                    style={{
                                      padding: '20px',
                                      color: '#ffffff'
                                    }}
                                  >
                                    <img
                                      src={`${process.env.PUBLIC_URL}/img/modulos/${subject.icon}`}
                                      alt={subject.name}
                                      style={{
                                        width: '100%',
                                        height: '200px',
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                      }}
                                    />
                                  </a>

                                  <div
                                    style={{
                                      textAlign: 'center',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {subject.name}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
